export const his = [
    {
        "type": "radiogroup",
        "name": "PHSTAT_A",
        "title": "Would you say your health in general is excellent, very good, good, fair, or poor?",
        "isRequired": true,
        "choices": [
          { "value": 1, "text": "Excellent" },
          { "value": 2, "text": "Very Good" },
          { "value": 3, "text": "Good" },
          { "value": 4, "text": "Fair" },
          { "value": 5, "text": "Poor" },
          { "value": 7, "text": "Refused" },
          { "value": 9, "text": "Don't Know" }
        ]
      }
]